// External Dependencies:
import React from 'react'

// Internal Dependencies:
import { loopArray } from 'utilities/arrays'
import Close from 'components/svg/close-circle-outline.svg'

class TextSearch extends React.Component {
	constructor( props ) {
		super( props )

		this.baseSuggestion = {
			name: 'Other',
			value: 'other'
		}

		this.state = {
			value: props.value,
			hasError: false,
			suggestions: [ this.baseSuggestion ],
			showSuggestions: false,
			searchTerm: '',
			valueDisplay: props.valueDisplay
		}
	}

	componentDidMount() {
		document.addEventListener( 'mousedown', this.handleClickOutside )
	}

	handleClickOutside = ( e ) => {
		if ( this.innerRef && ! this.innerRef.contains( e.target ) ) {
			this.handleClose()
		}
	}

	handleChange = ( e ) => {
		const { id, onChange } = this.props
		const value = e.target.value

		this.setState( {
			value
		} )

		onChange( id, value )
	}

	handleChangeSearch = ( e ) => {
		const searchTerm = e.target.value

		this.setState( {
			searchTerm
		} )

		// Get suggestions:
		this.getSuggestions( searchTerm )
	}

	handleClose = () => {
		this.setState( {
			showSuggestions: false
		} )
	}

	handleClick = ( e ) => {
		this.setState( {
			showSuggestions: ! this.state.showSuggestions
		} )

		this.input.focus()
	}

	handleClear = () => {
		const { id, onChange } = this.props

		this.setState( {
			value: '',
			valueDisplay: '',
			showSuggestions: false
		} )

		onChange( id, '', false )
	}

	handleClickSuggestion = ( e ) => {
		const { id, onChange } = this.props
		const { suggestions } = this.state
		const selectedId = e.currentTarget.getAttribute( 'data-id' )
		const selected = suggestions[ selectedId ]
		const value = selected.value
		const valueDisplay = selected.name

		this.setState( {
			value,
			valueDisplay,
			showSuggestions: false
		} )

		onChange( id, value, selected )
	}

	getSuggestions = ( search ) => {
		let { options } = this.props
		search = search.toLowerCase()

		if ( ! search || search.length < 3 ) {
			this.setState( {
				suggestions: [ this.baseSuggestion ]
			} )

			return
		}

		let suggestions = []

		loopArray( options, ( key, item ) => {
			if ( item.name.toLowerCase().includes( search ) ) {
				suggestions.push( item )
			}
		} )

		suggestions = suggestions.slice( 0, 10 )

		suggestions.push( this.baseSuggestion )

		this.setState( {
			suggestions
		} )
	}

	renderSuggestions = () => {
		const { suggestions } = this.state

		if ( ! suggestions ) {
			return null
		}

		return loopArray( suggestions, ( key, item ) => {
			return (
				<div className="-suggestion" key={ item.value } data-id={ key } onMouseDown={ this.handleClickSuggestion }>
					<div className="-title">{ item.name }</div>
				</div>
			)
		} )
	}

	render() {
		const { id, value, label, type, disabled, controlledByParent } = this.props
		const { hasError, showSuggestions, searchTerm, valueDisplay } = this.state
		let className = 'form-item form-text-search'

		if ( hasError ) {
			className += ' has-error'
		}

		let theValue = ''

		if ( controlledByParent ) {
			theValue = value ? value : ''
		} else {
			theValue = this.state.value ? this.state.value : ''
		}

		if ( type ) {
			className += ' form-' + type
		}

		if ( disabled ) {
			className += ' is-disabled'
		}

		let suggestionsClass = showSuggestions ? '-suggestions is-active' : '-suggestions'

		return (
			<div className={ className }>
				{ label &&
					<label htmlFor={ id } dangerouslySetInnerHTML={ { __html: label } } />
				}

				<input type="hidden" name={ id } value={ theValue } onChange={ this.handleChange } />

				<div className="-input-wrap" ref={ ( e ) => { this.innerRef = e } }>
					<div className="-input-wrap-inner">
						<div className="-input-display-value" onClick={ this.handleClick }>{ valueDisplay }</div>
					</div>

					<div className={ suggestionsClass }>
						<input type="text" placeholder="Search..." onChange={ this.handleChangeSearch } ref={ e => this.input = e } />

						<div className="-close">
							<Close onClick={ this.handleClear } />
						</div>

						<div className="-inner">
							{ this.renderSuggestions() }
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default TextSearch
